import { ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"
import { clsx } from "~/sdk/clx"
import { isSchedulingActive, type Scheduling } from "~/sdk/contentScheduling"

/**
 * @titleBy alt
 */
interface Link {
    /**
     * @title Texto alternativo
     */
    alt?: string
    /**
     * @title Imagem
     */
    src: ImageWidget
    /**
     * @title Link
     */
    href: string

    /**
     * @title Agendamento
     * @description Deixe este campo vazio para manter sempre visível
     */
    scheduling?: Scheduling
}

export interface Props {
    /**
     * @title Links
     * @description Link de promoção com imagem
     */
    links?: Link[]
}

const PromotionsLinks = ({ links = [] }: Props) => {
    if (!links?.length) return null

    const activeLinks = links.filter(
        ({ scheduling }) => isSchedulingActive(scheduling),
    )

    return (
        <div className={clsx('flex gap-2 items-center justify-center py-6 lg:py-12 w-full')}>
            <div
                className={clsx(
                    'grid grid-cols-1 max-w-[1730px] mx-auto w-full gap-3',
                    'lg:grid-cols-3',
                )}
            >
                {activeLinks.map((link, i) => (
                    <a
                        key={link.href ?? i}
                        className={clsx(
                            'aspect-[341/118] h-full overflow-hidden max-h-[7.375rem] max-w-[21.3125rem] mx-auto rounded-xl w-full',
                            'md:max-h-[12.375rem] md:max-w-[35.625rem]',
                            'lg:aspect-[570/198]',
                        )}
                        href={link.href}
                    >
                        <Image
                            alt={link.alt}
                            className='h-full object-cover w-full'
                            height={198}
                            src={link.src}
                            width={570}
                            loading='lazy'
                        />
                    </a>
                ))}
            </div>
        </div>
    )
}

export default PromotionsLinks
